module.exports = __webpack_public_path__ + "static/media/buxton-8.1607d5b5.jpg";